<template>
    <div>
        <div class="card my-3">
            <div class="card-header">反馈问卷填写</div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">问卷名称</th>
                    <td class="text-left align-middle" colspan="3">{{ surveyPaperInfo.surveyPaperName }}</td>
                </tr>
                <tr v-if="surveyTemplateInfo.surveyTemplateType===surveyTemplateType.V2_FOR_COURSE_TEACHER">
                    <th class="text-center align-middle" style="width: 10%">讲师课程</th>
                    <td class="text-left align-middle" colspan="3">
                        <ul class="mb-0">
                            <li v-for="teacherCourse in surveyPaperInfo.teacherCourseData">
                                {{ teacherCourse.personName }} - {{ teacherCourse.courseName }}
                            </li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">模板名称</th>
                    <td class="text-left align-middle" style="width: 40%">{{ surveyTemplateInfo.surveyTemplateName }}
                    </td>
                    <th class="text-center align-middle" style="width: 10%">模板类型</th>
                    <td class="text-left align-middle" style="width: 40%">
                        {{ surveyTemplateInfo.surveyTemplateTypeName }}
                    </td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">计算规则</th>
                    <td class="text-left align-middle" colspan="3">
                        <ul class="mb-0">
                            <li>
                                <template
                                    v-if="surveyTemplateInfo.excludeMaxCount===0 && surveyTemplateInfo.excludeMinCount===0">
                                    计算客观评价分数时，按所有提交的评价分数取平均值
                                </template>
                                <template v-else>
                                    计算客观评价分数时，按所有提交的评价分数，
                                    <template v-if="surveyTemplateInfo.excludeMaxCount !== 0">
                                        去掉{{ surveyTemplateInfo.excludeMaxCount }}个最高分，
                                    </template>
                                    <template v-if="surveyTemplateInfo.excludeMinCount !== 0">
                                        去掉{{ surveyTemplateInfo.excludeMinCount }}个最低分，
                                    </template>
                                    取平均值
                                </template>
                            </li>
                            <li>
                                所有客观评价项{{ surveyTemplateInfo.allowAllFullScore ? '允许' : '不允许' }}全部是满分
                            </li>
                            <li v-if="surveyTemplateInfo.requiredLessThenMinScore">
                                当客观评价项的分值低于最大分值的{{ surveyTemplateInfo.minScore }}%时，必须对该项填写主观评价说明
                            </li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="card-body" style="min-height: 500px">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">客观评价项 <span style="color:red;">{{ "（请拖动滑块进行评分）" }}</span></div>
                            <div class="col-auto text-right">总分：{{ sumScore }}</div>
                        </div>
                    </div>
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th class="text-center align-middle" style="width: 10%">序号</th>
                            <th class="text-center align-middle" style="width: 60%">评价项</th>
                            <th class="text-center align-middle" colspan="2">评价</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(item, index) in surveyData.scoreItems">
                            <tr>
                                <td class="text-center align-middle" :rowspan="needContent(item)? 2: 1">
                                    {{ index + 1 }}
                                </td>
                                <td class="text-left align-middle">{{ item.title }}</td>
                                <td class="text-left align-middle" style="width: 20%">
                                    <input type="range" style="width: 100%" min="1" :max="item.maxScore"
                                           v-model.number="item.score">
                                </td>
                                <td class="text-center align-middle" style="width: 10%">
                                    <label>{{ "分数：" + item.score }}</label>
                                    <!-- <input type="number" class="form-control" min="1" :max="item.maxScore"
                                           v-model.number="item.score" onkeydown="return false" onkeyup="return false" oncontextmenu="return false"> -->
                                </td>
                            </tr>
                            <tr v-if="needContent(item)">
                                <td colspan="3">
                                    <textarea class="form-control"
                                              :class="{'is-invalid': needContent(item) && !item.content}"
                                              rows="2" placeholder="您对此项反馈的评分较低，请填写具体原因"
                                              v-model="item.content"></textarea>
                                    <div class="invalid-feedback">
                                        您对此项反馈的评分较低，请填写具体原因
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="card mt-3" v-if="surveyData.contentItems.length!==0">
                    <div class="card-header">主观评价项</div>
                    <div class="card-body">
                        <div class="form-group" v-for="(item, index) in surveyData.contentItems"
                             :class="{'mb-0': index===surveyData.contentItems.length-1}">
                            <label>{{ item.title }}</label>
                            <textarea class="form-control" v-model="item.content" rows="3"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" @click="btnSubmitSurveyPaper_Click">提交反馈</button>
            </div>
        </div>


    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import dictionary from "@/utils/dictionary";

export default {
    name: "StudentSurveyPaperEdit",
    data: function () {
        return {
            surveyTemplateType: dictionary.surveyTemplateType,
            surveyPaperId: this.$route.params.surveyPaperId,

            surveyPaperInfo: {},
            surveyTemplateInfo: {},

            surveyData: {
                scoreItems: [],
                contentItems: [],
            },
        };
    },
    computed: {
        sumScore() {
            let result = 0;
            for (let item of this.surveyData.scoreItems) {
                result += item.score;
            }
            return result;
        }
    },
    mounted() {
        this.getSurveyPaperInfo();
    },
    methods: {
        getSurveyPaperInfo() {
            studyApi.survey.paper.getSurveyPaperInfo(this.surveyPaperId).then(res => {
                this.surveyPaperInfo = res.data;
                this.getSurveyTemplateInfo(this.surveyPaperInfo.surveyTemplateId);
            });
        },

        getSurveyTemplateInfo(surveyTemplateId) {
            studyApi.survey.template.getSurveyTemplateInfo(surveyTemplateId).then(res => {
                this.surveyTemplateInfo = res.data;

                let data = {
                    scoreItems: [],
                    contentItems: [],
                };
                for (let item of this.surveyTemplateInfo.surveyItemData) {
                    if (item.surveyTemplateItemType === dictionary.surveyTemplateItemType.V1_SCORE) {
                        let scoreItem = {
                            title: item.surveyTemplateItem,
                            maxScore: item.maxScore,
                            surveyTemplateItemId: item.surveyTemplateItemId,
                            surveyTemplateItemType: item.surveyTemplateItemType,
                            score: item.maxScore,
                            content: '',
                        };
                        data.scoreItems.push(scoreItem);
                    } else {
                        let contentItem = {
                            title: item.surveyTemplateItem,
                            surveyTemplateItemId: item.surveyTemplateItemId,
                            surveyTemplateItemType: item.surveyTemplateItemType,
                            content: '',
                        };
                        data.contentItems.push(contentItem);
                    }
                }

                this.surveyData = data;
            });
        },

        needContent(item) {
            let result = false;
            if (this.surveyTemplateInfo.requiredLessThenMinScore) {
                result = item.score < (item.maxScore * this.surveyTemplateInfo.minScore / 100);
            }

            return result;
        },

        btnSubmitSurveyPaper_Click() {

            let isValidate = true;
            if (!this.surveyTemplateInfo.allowAllFullScore) {
                isValidate = false;
                for (let item of this.surveyData.scoreItems) {
                    if (item.score !== item.maxScore) {
                        isValidate = true;
                        break;
                    }
                }

                if (!isValidate) {
                    alert('反馈规则不允许所有评分项均为满分');
                    return;
                }
            }
            if (this.surveyTemplateInfo.requiredLessThenMinScore) {
                isValidate = true;
                for (let item of this.surveyData.scoreItems) {
                    if ((item.score < (item.maxScore * this.surveyTemplateInfo.minScore / 100)) && !item.content) {
                        isValidate = false;
                        break;
                    }
                }

                if (!isValidate) {
                    alert('反馈规则要求当客观评分项的评分值小于最大值的' + this.surveyTemplateInfo.minScore + '%时，必须填写主观评价原因');
                    return;
                }
            }

            if (isValidate) {
                if (confirm('是否提交反馈？反馈提交后不能再次填写')) {
                    let info = {
                        surveyPaperId: this.surveyPaperId,
                        studentId: this.$store.state.userInfo.userId,
                        surveyScore: this.sumScore,
                        scoreDetail: JSON.stringify(this.surveyData.scoreItems),
                        contentDetail: JSON.stringify(this.surveyData.contentItems)
                    };

                    studyApi.survey.insertSurveyInfo(info).then(res => {
                        this.$router.push('/student/surveyManage');
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>